import * as React from 'react';

import Skills16 from './Skills16';

export const skills16 = () => <Skills16 />;

export default {
    title: 'Icon/Fill/Skills16',
    component: Skills16,
    parameters: {
        notes: "`import Skills16 from 'box-ui-elements/es/icon/fill/Skills16';`",
    },
};
